import pushEventAddToCartEshop from '#/local/service/dataLayer/pushEventAddToCartEshop'
import searchReportEshop from '#/local/service/searchReport/eshop'

import { redrawSnippets } from '#/local/service'

import type { AddToCartAfter } from '#/global/types'

const addToCartAfter = (event: CustomEvent<AddToCartAfter>) => {
    const detail = event.detail
    const { productEshopList } = detail

    const hasEshopProducts = productEshopList.length > 0
    const isSuccess = productEshopList.every(product => product.isSuccess)

    if (isSuccess) {
        redrawSnippets()
    }

    if (hasEshopProducts) {
        for (const payload of productEshopList) {
            if (payload.isSuccess) {
                pushEventAddToCartEshop(payload.product, payload.quantitySales)
                searchReportEshop(payload.product.code)
            }
        }
    }
}

export default addToCartAfter
